import styled from "styled-components";
import {ExclamationCircleOutlined} from "@ant-design/icons";

export const LateStartIcon = styled(ExclamationCircleOutlined)`
    margin-left: 3px;
    margin-right: 3px;
`;

export const EarlyEndIcon = styled(ExclamationCircleOutlined)`
    margin-left: 3px;
`;

export const EndTimeSpan = styled.span`
    margin-left: 3px;
`;
